export const messages = {
  en: {
    upShopHouseDetail: {
      orderTitle: 'Order Details',
      goodsTitle: 'Product Information',
      orderId: 'Order ID',
      applicant: 'Applicant',
      applyTime: 'Apply Time',
      orderStatus: 'Order Status',
      remark: 'Remark',
      serialNumber: 'No.',
      productName: 'Product Name',
      productCode: 'Product Code',
      specification: 'Specification',
      quantity: 'Quantity',
      price: 'Price',
      amount: 'Amount',
      backBtn: 'Back'
    }
  },
  zh: {
    upShopHouseDetail: {
      orderTitle: '订单详情',
      goodsTitle: '商品信息',
      orderId: '工单编码',
      applicant: '申请人',
      applyTime: '申请时间',
      orderStatus: '订单状态',
      remark: '备注',
      serialNumber: '序号',
      productName: '商品名称',
      productCode: '商品编号',
      specification: '规格',
      quantity: '数量',
      price: '价格',
      amount: '金额',
      backBtn: '返回'
    }
  }
}